import { render, staticRenderFns } from "./AssistantNotificationSettingDialog.vue?vue&type=template&id=45b80362&scoped=true"
import script from "./AssistantNotificationSettingDialog.vue?vue&type=script&lang=js"
export * from "./AssistantNotificationSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./AssistantNotificationSettingDialog.vue?vue&type=style&index=0&id=45b80362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b80362",
  null
  
)

export default component.exports